import React, { FC, createContext } from 'react';

import App from '../../../models/app';
import { payloadFromApp } from '../../../utils';
import fsc from 'fsc';
import styled from 'styled-components';
import shareIconAndroid from '../../../icons/share-android.svg';
import shareIconiOS from '../../../icons/share-ios.svg'
import { isiOS, isAndroid } from 'config';

export const ShareAppButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const ShareImg = styled.img<any>`
  ${({ paddingTop = false }) => `
    cursor: pointer;
    margin-left: auto;
    padding-right: 16px;
    padding-top: ${paddingTop ? '6px' : 'none'};
  `}
`;

interface ShareAppButtonProps {
  app: App;
  paddingTop?: boolean;
  id: String
}

const createMobileLink = ({ openwith = 'fitbit', appId }: {
  openwith: string;
  appId: string;
}) => {

  let mobileLink: string;
  mobileLink = `https://gallery.fitbit.com/details/${appId}?openwith=${openwith}`;

  return mobileLink;
};

export const ShareAppButton: FC<ShareAppButtonProps> = ({
  app,
  id, 
  paddingTop = false
}) => {
  const { id: appId, developer } = app;
  
  let savedNavigator = (window.navigator as any);
  return (
    <ShareImg
      id={id}
      aria-label={id}
      src={isiOS ? shareIconiOS : shareIconAndroid}
      paddingTop={paddingTop}
      onClick={
        async () => {
          fsc
            .view(`${app.isClock ? 'Clock' : 'App'} Details`)
            .Tapped(`Share ${app.isClock ? 'clock' : 'app'}`)
            .withPayload(payloadFromApp(app))
            .send();
          await savedNavigator.share({
            title: app.name,
            url: createMobileLink({openwith: 'fitbit', appId: app.id})
          })
        }
      }
    >
    </ShareImg>
  );


};
